import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import screenfull from 'screenfull'
import BaiduMap from 'vue-baidu-map'
import JsonExcel from 'vue-json-excel'
import * as $api from './api/index'
import BackHead from './components/BackHead'
import BigScreenHead from './components/BigScreenHead'
import Search from './components/Search'
import Pagination from './components/Pagination'
import './assets/iconfont/iconfont.css';



Vue.use(ElementUI)
Vue.use(BaiduMap, {
    ak: 'hYt4KhnT3ZdbDuslQQC225Sph69tNx42'
})
Vue.component('BackHead', BackHead)
Vue.component('BigScreenHead', BigScreenHead)
Vue.component('Search', Search)
Vue.component('Pagination', Pagination)
Vue.component('downloadExcel', JsonExcel)

Vue.prototype.$api = $api
Vue.prototype.$screenfull = screenfull
Vue.config.productionTip = false

//文本超出隐藏
Vue.directive(
    'overflow', {
        inserted: function(el) {
            el.classList.add('ellipse');
            el.setAttribute('title', el.innerHTML)
        }
    })

//文本超出隐藏
Vue.directive(
    'loanStatus', {
        inserted: function(el) {
            switch (el.innerHTML) {
                case '0':
                    el.style.color = '#F55B54'
                    el.innerHTML = '未接受'
                    break;
                case '1':
                    el.style.color = '#ffb300'
                    el.innerHTML = '已接受'
                    break;
                case '2':
                    el.style.color = '#4bc54f'
                    el.innerHTML = '进行中'
                    break;
                case '3':
                    el.style.color = '#437ee9'
                    el.innerHTML = '已完成'
                    break;
            }
        }
    })

//时间过滤器
Vue.filter('timeFomart', function(val) {
    if (!val || val.slice(0, 4) == '1991') return "";
    if (!val || val.slice(0, 4) == '1990') return "";
    if (!val || val.slice(0, 4) == '0001') return "";
    return val.slice(0, 10)
})

//企业性质过滤器
Vue.filter('companyFomart', function(val) {
    if (val == 1) return '央企';
    if (val == 2) return '国企';
    if (val == 3) return '私企';
    if (val == 4) return '其他';
})

//行业过滤器
Vue.filter('hangYeFomart', function(val) {
    if (val == 1) return '建筑企业';
    if (val == 2) return '租赁企业';
    if (val == 3) return '其他';
})

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')